import $ from 'jquery';

import RespondService from '../../Services/Respond';
import constants from '../../constants';

const HEADER_ATTR = 'data-exhibition-header';
const COLUMN_ATTR = 'data-exhibition-column';
const IMAGE_COLUMN_ATTR = 'data-exhibition-column-image';
const COLUMN_LOCKED_HEIGHT_CLASS = 'block-exhibition-column--locked-height';
const HEADER_CONTENT_SELECTOR = '[' + HEADER_ATTR + '] .block-exhibition__content';
const SCREEN_OFFSET_PX = 100;
const RESIZE_DEBOUNCE_TIMER = 100;

export default class HeaderScrollHandler {
    constructor() {
        this.resizeDebouncer = null;
        if ($('[' + HEADER_ATTR + ']').length) {
            this.setupEvents();
            this.refresh();
        }
    }

    setupEvents() {
        $(document).on('scroll', (ev) => { this.onScroll(ev); })
        $(window).on('resize', (ev) => { this.onResize(ev); })
    }

    onScroll(ev) {
        this.refresh();
    }

    onResize() {
        clearInterval(this.resizeDebouncer);

        this.resizeDebouncer = setTimeout(() => {
            this.refresh();
        }, RESIZE_DEBOUNCE_TIMER);
    }

    refresh() {
        if(RespondService.from(constants.BREAKPOINT_M)) {
            this.updateImageColumnWidth();
            this.lockHeights();
            this.positionElements()
        } else {
            this.resetElements();
        }
    }

    getDocumentScrollPercentage() {
        const doc = document.documentElement;
        const body = document.body;
        const st = 'scrollTop';
        const sh = 'scrollHeight';
        const percent = (doc[st]||body[st]) / ((doc[sh]||body[sh]) - doc.clientHeight) * 100;

        return percent;
    }

    getScrollPercentage() {
        const header = $(HEADER_CONTENT_SELECTOR);
        const doc = document.documentElement;
        const body = document.body;
        const headerOffset = header.offset()
        const scrollTop = (doc.scrollTop||body.scrollTop) - headerOffset.top
        const height = header.height()

        if (scrollTop < 0) {
            return 0;
        }

        const percent = scrollTop / ((height));

        return percent;
    }

    lockHeights() {
        const headerContent = $(HEADER_CONTENT_SELECTOR);
        let combinedHeight = 0;
        let minHeight = 0;

        headerContent.css('height', 'none');

        $('[' + COLUMN_ATTR + ']').each((index, element) => {
            const $column = $(element);
            const height = this.getColumnHeight($column);
            minHeight = height > minHeight ? height : minHeight;
            combinedHeight += height;
        });

        const screenOffset = this.getScreenOffsetHeight();

        combinedHeight -= screenOffset;
        headerContent.css('height', combinedHeight < minHeight ? minHeight : combinedHeight);
    }

    getColumnHeight(colElement) {
        return $(colElement).find('.block-exhibition-column__content').height();
    }
    getScreenOffsetHeight() {
        const screenHeight = $(window).height();

        return (screenHeight-SCREEN_OFFSET_PX);
    }

    updateImageColumnWidth() {
        const imageColumn = $('[' + IMAGE_COLUMN_ATTR + ']');
        const windowWidth = $('body').innerWidth();

        imageColumn.css({
            width: windowWidth / 2
        })
    }

    resetElements() {
        const contentColumn = $('[' + COLUMN_ATTR + ']:not([' + IMAGE_COLUMN_ATTR + '])');
        const imageColumn = $('[' + IMAGE_COLUMN_ATTR + ']');
        const headerContent = $(HEADER_CONTENT_SELECTOR);

        contentColumn.removeAttr('style');
        imageColumn.removeAttr('style');
        headerContent.removeAttr('style');
    }

    positionElements() {
        const scrollPercentage = this.getScrollPercentage();
        const screenOffset = this.getScreenOffsetHeight();

        const contentColumn = $('[' + COLUMN_ATTR + ']:not([' + IMAGE_COLUMN_ATTR + '])');
        const imageColumn = $('[' + IMAGE_COLUMN_ATTR + ']');
        const contentHeight = this.getColumnHeight(contentColumn);
        const imageHeight = this.getColumnHeight(imageColumn);
        const windowHeight = $(window).height();
        const headerContent = $(HEADER_CONTENT_SELECTOR);
        const containerHeight = headerContent.height();
        const scrollPixels = containerHeight * scrollPercentage;
        const maxContentOffset = (containerHeight - contentHeight);
        const offsettedContentHeight = (contentHeight - screenOffset);


        let shorterEndPercentage = contentHeight / containerHeight;
        const stopPagePercentage = screenOffset / containerHeight;
        shorterEndPercentage = shorterEndPercentage - stopPagePercentage;
        const targetPercentageOverflow = (scrollPercentage/shorterEndPercentage);
        const targetPercentage = targetPercentageOverflow > 1 ? 1 : targetPercentageOverflow;
        const pixelsScrolled = offsettedContentHeight * targetPercentage;
        const pixelsScrolledOverflow = offsettedContentHeight * targetPercentageOverflow;

        const contentColumnDefaultCss = {
            position: 'relative',
            transform: 'translate(0, 0)',
            top: 'auto',
            width: 'auto',
            left: 'auto'
        };

        const imageColumnDefaultCss = {
            position: 'relative',
            transform: 'translate(0, 0)',
            top: 'auto',
            bottom: 'auto',
            left: 'auto'
        };

        let imageColumnCss = imageColumnDefaultCss;

        if (targetPercentage >= 0 && pixelsScrolled > 0) {
            imageColumnCss = {
                position: 'fixed',
                transform: 'none',
                top: '0',
                bottom: 'auto'
            };
        } else {
            imageColumnCss = {
                position: 'relative',
                transform: 'none',
                top: 'auto',
                bottom: 'auto',
                left: 'auto'
            };
        }

        if (targetPercentage === 1 && contentHeight < imageHeight) {
            imageColumnCss = {
                position: 'relative',
                transform: 'translate(0, ' + pixelsScrolled + 'px)',
                top: 'auto',
                left: 'auto'
            };
        }

        this.updateImageColumnWidth();

        let contentColumnCss = contentColumnDefaultCss;

        if (targetPercentage === 1 && contentHeight < imageHeight) {
            if(scrollPercentage*containerHeight < containerHeight-screenOffset) {
                const contentColumnOffsets = contentColumn.offset();
                const contentColumnWidth = contentColumn.innerWidth();
                
                contentColumnCss = {
                    position: 'fixed',
                    transform: 'translate(0, -' + (contentHeight - screenOffset) + 'px)',
                    top: '0',
                    width: contentColumnWidth,
                    left: contentColumnOffsets.left 
                };
            } else {
                let newPos = containerHeight - contentHeight;
                contentColumnCss.transform = 'translate(0, ' + newPos + 'px)';
            }
        } else {
            if (contentHeight > imageHeight) {
                headerContent.css('height', 'auto');

                const pixelsOverscrolled = pixelsScrolledOverflow - offsettedContentHeight < 0 ? 0 : pixelsScrolledOverflow - offsettedContentHeight;
                const imageWindowOffsetOverflow = (imageHeight - windowHeight);
                const imageWindowOffset = (imageWindowOffsetOverflow < 0 ? 0 : imageWindowOffsetOverflow);
                const targetOverflow = ((-imageWindowOffsetOverflow) - SCREEN_OFFSET_PX);

                imageColumnCss = {
                    position: 'relative',
                    transform: 'translate(0, 0)',
                    top: 'auto',
                    bottom: 'auto',
                    left: 'auto'
                };

                if (pixelsScrolled > imageWindowOffset) {
                    imageColumnCss.position = 'fixed';
                    imageColumnCss.top = -imageWindowOffset + 'px';
                }
                if (targetPercentage >= 1 && (pixelsOverscrolled) >= targetOverflow) {
                    imageColumnCss.position = 'absolute';
                    imageColumnCss.top = 'auto';
                    imageColumnCss.bottom = '0px';
                }
            }

            if (targetPercentage < 0) {
                let offsetContentPixels = containerHeight * scrollPercentage;
                offsetContentPixels = offsetContentPixels > maxContentOffset ? maxContentOffset : offsetContentPixels;
                contentColumnCss.transform =  'translate(0, ' + offsetContentPixels + 'px)';

            } else {
                contentColumnCss.transform =  'translate(0, 0)';
            }
        }

        if (windowHeight > contentHeight && windowHeight > imageHeight) {
            contentColumnCss = contentColumnDefaultCss;
            imageColumnCss = imageColumnDefaultCss;
        }

        contentColumn.css(contentColumnCss);
        imageColumn.css(imageColumnCss);
    }
}


// WEBPACK FOOTER //
// ./www/wp-content/themes/accelerator/assets/scripts/src/App/Exhibition/HeaderScrollHandler.js